import { useEffect, useRef, useState } from 'react';
import { DEFAULT_CONFIG } from '../../constants';
import type { Consultation } from '../../types';

export function ConsultationCard({
  consultation,
  reportId,
  onExpose
}: {
  consultation: Consultation;
  reportId: string;
  onExpose: () => void;
}) {
  const rootRef = useRef<HTMLDivElement>(null);
  const exposed = useRef(false);
  const [imageFailed, setImageFailed] = useState(false);
  const title = consultation.title || DEFAULT_CONFIG.consult_title;
  const content = consultation.content || DEFAULT_CONFIG.consult_content;
  const qrURL = consultation.qr_url || DEFAULT_CONFIG.consult_qr_url;

  useEffect(() => {
    exposed.current = false;
    setImageFailed(false);
    const node = rootRef.current;
    if (!node || !('IntersectionObserver' in window)) return;
    const observer = new IntersectionObserver(
      (entries) => {
        if (!exposed.current && entries.some((item) => item.isIntersecting)) {
          exposed.current = true;
          onExpose();
          observer.disconnect();
        }
      },
      { threshold: 0.35 }
    );
    observer.observe(node);
    return () => observer.disconnect();
  }, [reportId, onExpose]);

  return (
    <div ref={rootRef} className="service-cta">
      <div>
        <h4>{title}</h4>
        <p>{content}</p>
      </div>
      <div className="service-qr">
        <div className="service-qr-frame">
          {!imageFailed ? (
            <img src={qrURL} alt="GEO 服务咨询二维码" onError={() => setImageFailed(true)} />
          ) : (
            <div className="qr-fallback">二维码暂不可用</div>
          )}
        </div>
        <span>扫码咨询</span>
      </div>
    </div>
  );
}
